<template>
  <el-card
    class="surveyors"
    shadow="never"
  >
    <div
      slot="header"
      class="surveyors__header"
    >
      <span class="title">调查员</span>
      <el-button
        style="float: right; padding: 3px 0"
        type="text"
        @click="createDialogVisible=true"
      >+ 创建调查员</el-button>
    </div>
    <el-table
      :data="surveyors"
      style="width: 100%"
      border
    >
      <el-table-column
        type="index"
        label="#"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="联系方式"
      ></el-table-column>
      <el-table-column
        label="职位"
        width="120"
        align="center"
      >调查员</el-table-column>
      <el-table-column
        label="调查进度"
        width="300"
        align="center"
      >
        <template #default="{row}">
          <div class="progress-bar-wrapper">
            <div class="progress-bar">
              <el-progress
                :status="row.progress.total && row.progress.total===row.progress.completed?'success':''"
                :show-text="false"
                :percentage="row.progress.total?row.progress.completed/row.progress.total*100:0"
              ></el-progress>
            </div>
            <div class="label">
              {{ row.progress.completed }} / {{ row.progress.total }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        align="center"
      >
        <div class="actions">
          <el-button
            slot="reference"
            type="text"
            @click="editSurveyor()"
          >修改</el-button>
        </div>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="createDialogVisible"
      @close="createDialogVisible=false"
    >
      <el-form
        ref="surveyorForm"
        :model="surveyorForm"
        label-width="80px"
      >
        <el-form-item label="姓名">
          <el-input v-model="surveyorForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="surveyorForm.mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="createSurveyor"
          >立即创建</el-button>
          <el-button @click="createDialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { createSurveyor, getSurveyors } from "@/api/surveyors";
import { mapMutations /*mapGetters*/ } from "vuex";

export default {
  name: "task-person",
  data() {
    return {
      selectedSurveyors: [],
      renderFunc(h, option) {
        return (
          <div class="select-item">
            <span class="name">{option.name} - </span>
            <span class="mobile">{option.mobile}</span>
          </div>
        );
      },
      filterMethod(query, surveyor) {
        const objective = `${surveyor.name}${surveyor.mobile}`;
        return objective.indexOf(query) > -1;
      },
      createDialogVisible: false,
      surveyorForm: {
        name: "",
        mobile: ""
      },
      surveyors: []
    };
  },
  computed: {
    surveyId() {
      return this.$route.params.id;
    }
  },

  mounted() {
    this.getSurveyors();
  },

  methods: {
    handleChange() {
      this.setSelected([...this.selectedSurveyors]);
    },
    ...mapMutations({
      setSelected: "SET_SELECTED",
      setSurveyors: "SET_SURVEYORS"
    }),
    createSurveyor() {
      createSurveyor(this.surveyorForm)
        .then(() => {
          this.$message.success("调查员创建成功");
          this.getSurveyors();
          this.createDialogVisible = false;
        })
        .catch(err => {
          this.$message.error(
            "调查员创建失败：" + ((err.response || {}).data || {}).message ||
              "请求出现错误，请稍后再试"
          );
        });
    },
    editSurveyor() {
      this.$message.warning("暂时不可修改");
    },
    getSurveyors() {
      getSurveyors({ surveyId: this.surveyId }).then(res => {
        this.surveyors = res.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.surveyors {
  height: 100%;
  background-color: #fff;
  overflow-y: scroll;
  &__header {
    .title {
      font-weight: bold;
      font-size: 16px;
    }
  }
  &__transfer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 90px);
    margin-top: 20px;
    .el-transfer-panel {
      flex: 0.35;
      height: 100%;
      .el-transfer-panel__list {
        height: calc(100% - 102px);
      }
    }
    .el-transfer__buttons {
      flex: 0.12;
      text-align: center;
      min-height: inherit;
      .el-button {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
    }
    .el-transfer-panel__item {
      display: block;
      height: 50px;
    }
    .el-transfer-panel__body {
      height: 100%;
    }
    .el-checkbox__label {
      .name,
      .mobile {
        font-size: 18px;
        font-weight: 400;
        line-height: 100%;
      }
      .name {
        color: #333;
      }
      .mobile {
        color: #666;
      }
    }
  }
}
.actions {
  button {
    margin: 0 5px;
    padding: 0;
  }
}

.progress-bar-wrapper {
  display: flex;
  align-items: center;
  .progress-bar {
    width: 220px;
  }
  .label {
    font-size: 14.4px;
    padding: 5px;
  }
}
</style>
